import React from "react";

export default ({ label, md = "", ...props }) => {
  return <hr style={{ borderTop: "2px solid rgba(0, 0, 0, .1)" }} />;
};
